import { useEffect, useState } from "react";

function parseRouteFromHash(hash) {
    const h = hash || window.location.hash || "#/recipes";
    if (h === "#/recipes" || h === "#/") return { route: "recipes", params: {} };
    if (h === "#/admin" || h === "#/") return { route: "admin", params: {} };
    if (h === "#/add-recipe") return { route: "add-recipe", params: {} };
    if (h === "#/preview-recipe") return { route: "preview-recipe", params: {} };

    if (h.startsWith("#/edit-recipe")) {
        const recipeId = h.replace("#/edit-recipe/", "");
        return { route: "edit-recipe", params: { recipeId } };
    }
    if (h.includes("#/report-bug")) return { route: "report-bug", params: {} };
    if (h === "#/cookie-policy") return { route: "cookie-policy", params: {} };

    // Obsługa inventory z parametrami query string
    if (h === "#/inventory" || h === "#/lodowka" || h === "#/spizarnia" || h.startsWith("#/inventory?")) {
        const queryParams = {};
        if (h.includes("?")) {
            const queryString = h.split("?")[1];
            const urlParams = new URLSearchParams(queryString);
            urlParams.forEach((value, key) => {
                queryParams[key] = value;
            });
        }
        return { route: "inventory", params: queryParams };
    }

    if (h === "#/favorite") return { route: "favorite", params: {} };
    if (h === "#/profile") return { route: "profile", params: {} };
    if (h === "#/zdjecie") return { route: "zdjecie", params: {} };
    if (h === "#/camera") return { route: "camera", params: {} };
    if (h === "#/savepicture") return { route: "savepicture", params: {} };
    if (h === "#/scan") return { route: "scan", params: {} };
    if (h === "#/substitutes") return { route: "substitutes", params: {} };
    if (h === "#/lemmatization") return { route: "lemmatization", params: {} };

    // Obsługa zakupy z parametrami query string (np. ?tab=shared)
    if (h === "#/zakupy" || h.startsWith("#/zakupy?")) {
        const queryParams = {};
        if (h.includes("?")) {
            const queryString = h.split("?")[1];
            const urlParams = new URLSearchParams(queryString);
            urlParams.forEach((value, key) => {
                queryParams[key] = value;
            });
        }
        return { route: "zakupy", params: queryParams };
    }
    
    if (h === "#/list-settings") return { route: "list-settings", params: {} };
    if (h.startsWith("#/recipe/")) {
        const params = h.replace("#/recipe/", "");
        const [recipeId, fromLink] = params.split("/");
        return { route: "recipe", params: { recipeId, fromLink } };
    }
    if (h.startsWith("#/shared/")) {
        const shareId = h.replace("#/shared/", "");
        return { route: "shared", params: { shareId } };
    }
    return { route: "recipes", params: {} };
}

export default function useHashRoute() {
    const [{ route, params }, setState] = useState(() => parseRouteFromHash(window.location.hash));

    useEffect(() => {
        const onHashChange = () => setState(parseRouteFromHash(window.location.hash));
        window.addEventListener("hashchange", onHashChange);
        return () => window.removeEventListener("hashchange", onHashChange);
    }, []);

    return { route, params };
}
